import axios from 'axios';

const GUARDIAN_TOKEN_KEY = 'edupro-guardian-token';

export function getGuardianToken(): string | null {
  return localStorage.getItem(GUARDIAN_TOKEN_KEY);
}
export function setGuardianToken(token: string | null) {
  if (token) localStorage.setItem(GUARDIAN_TOKEN_KEY, token);
  else localStorage.removeItem(GUARDIAN_TOKEN_KEY);
}

// Dedicated instance — a guardian spans schools, so it carries only its own
// bearer token, never the tenant X-School-Code header or the staff auth store.
const guardianAxios = axios.create({ baseURL: '/api/v1' });
guardianAxios.interceptors.request.use((config) => {
  const t = getGuardianToken();
  if (t) config.headers.set('Authorization', `Bearer ${t}`);
  return config;
});

export interface GuardianSession {
  guardian: { id: string; name: string; username: string; scope: 'guardian' };
  tokens: { accessToken: string; refreshToken: string; expiresIn: number };
}

export interface GuardianChild {
  studentLegacyId: string;
  schoolId: string;
  schoolName: string;
  admissionNo: string;
  studentName: string;
  className: string | null;
  sectionName: string | null;
}

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export const GuardianApi = {
  login: async (username: string, password: string): Promise<GuardianSession> =>
    unwrap(
      // Raw axios (no guardian token yet, no tenant header) for login itself.
      await axios.post('/api/v1/auth/guardian/login', { username, password }),
    ),
  children: async (): Promise<GuardianChild[]> =>
    unwrap(await guardianAxios.get('/guardian/children')),
};
